import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import chunk from 'lodash.chunk';
import ActivityLink from './ActivityLink';
import { PROBE_DETAIL } from '../../constants/shared/CommonConstants';
import { ACTIVITIES_LIST } from '../../constants/reading/DemoModeConstants';
import { generateReactKey } from '../../utils/shared/commonUtils';
import './ActivitiesSection.scss';

const { WORDS_IN_ROW } = PROBE_DETAIL;

const NO_ACTIVITIES_MESSAGE = 'No activities found.';

const ActivitiesSection = ({ activities, classNames, onClickHandler, countInRow }) => {
    return (
        <div className={`activities-section ${classNames}`} data-tour-step={ACTIVITIES_LIST}>
            {isEmpty(activities)
                ? NO_ACTIVITIES_MESSAGE
                : chunk(activities, countInRow).map((activitiesRow, index) => (
                      <div key={generateReactKey(index)} className="activities-row">
                          {activitiesRow.map(({ id, name, url }) => {
                              return (
                                  <ActivityLink
                                      id={id}
                                      key={generateReactKey(id)}
                                      content={
                                          <>
                                              <i className="file-icon" />
                                              <span className="name">{name}</span>
                                          </>
                                      }
                                      url={url}
                                      onClick={() => onClickHandler({ id, name, url })}
                                  />
                              );
                          })}
                      </div>
                  ))}
        </div>
    );
};

ActivitiesSection.defaultProps = {
    activities: [],
    classNames: '',
    countInRow: WORDS_IN_ROW,
    onClickHandler: () => {},
};

ActivitiesSection.propTypes = {
    activities: PropTypes.array,
    classNames: PropTypes.string,
    countInRow: PropTypes.number,
    onClickHandler: PropTypes.func,
};

export default ActivitiesSection;
